import React from 'react';
import DispensingEditablePopup from '../dispensingEditablePopup/DispensingEditablePopup';

export const columnSetter = (reloadFunc, returnModuleFunc, areas, modules) => {
  const columns = [
    {
      Header: '불출정보',
      columns: [
        {
          Header: <div></div>,
          accessor: 'index',
        },
        {
          Header: '고유번호',
          accessor: 'modelNo',
        },
        {
          Header: '장치명',
          accessor: 'modelNm',
        },
        {
          Header: <span title={`이동형 : 착용자가 소지하는 장치${'\n'}휴대형 : 특정 장소에 고정/고정하는 장치`}>운용유형</span>,
          accessor: 'moduleTypeNm',
        },
        {
          Header: <span title="장치가 검지하는 유형">검지유형</span>,
          accessor: 'moduleScnNm',
        },
        {
          Header: <span title="장치를 불출받고 작업중인 인원">사용자</span>,
          accessor: 'userNm',
        },
        {
          Header: <span title="장치를 불출받고 작업중인 인원의 연락처">연락처</span>,
          accessor: 'userTel',
        },
        {
          Header: <span title="장치를 불출해준 인원">관리감독자</span>,
          accessor: 'instNm',
        },
        {
          Header: <span title="휴대형 장치를 고정한 장소">위치정보</span>,
          accessor: 'areaNm',
        },
        {
          Header: <span title="장치를 불출한 날짜 및 시간">불출일시</span>,
          accessor: 'dispensingDt',
        },
        {
          Header: <span title="장치를 반납한 날짜 및 시간">반납일시</span>,
          accessor: 'receivingDt',
        },
        {
          id: 'mButton',
          Header: () => (
            <div>
            </div>
          ),
          Cell: ({ row }) => (
            <DispensingEditablePopup dispensing={row.original}
                                     dataReloadFunc={reloadFunc} 
                                     areas={areas}
                                     modules={modules.filter(x => x.dispensingFlag === 0)}>
              <div>
                <button className="table-search-submit btn btn-info">수정</button>
              </div>
            </DispensingEditablePopup>
          ),
        },
        {
          id: 'rButton',
          Header: () => (
            <div>
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <button onClick={() => {returnModuleFunc([row.original.dispensingIdx])}} 
                      className="table-search-submit btn btn-info">반납</button>
            </div>
          ),
        },
      ],
    },
  ];

  return columns;
};
